import type { IntegrityStatus } from "../contracts/scoring";
import type { VerificationLevel } from "../integrity/integrityLabels";

export interface TrustedScoreInput {
  scoreCalculated: number | null;
  isAuthorizedForScoring: boolean;
  hasServerProof: boolean;
  usedClientOnlyFlags: boolean;
}

export interface TrustedScoreOutput {
  scoreDisplayed: number | null;
  integrityStatus: IntegrityStatus;
  verificationLevel: VerificationLevel;
}

export function buildTrustedScore(input: TrustedScoreInput): TrustedScoreOutput {
  if (!input.isAuthorizedForScoring) {
    return { scoreDisplayed: null, integrityStatus: "FAIL", verificationLevel: "NONE" };
  }

  if (input.usedClientOnlyFlags) {
    return { scoreDisplayed: null, integrityStatus: "UNVERIFIABLE", verificationLevel: "NONE" };
  }

  if (input.hasServerProof) {
    return {
      scoreDisplayed: input.scoreCalculated,
      integrityStatus: "PASS",
      verificationLevel: "REMOTE"
    };
  }

  // ✅ LOCAL PASS
  return {
    scoreDisplayed: input.scoreCalculated,
    integrityStatus: "PASS",
    verificationLevel: "LOCAL"
  };
}
